import { Page } from "@flexidao/dto";
import { useTenantDisplay } from "./use-tenant-display";

export const useVisiblePages = (): Array<Page> => {
    const displaySettings = useTenantDisplay();

    return displaySettings.visibleNavigationPageIds;
};
